import { FindCategoriesFilterOptionsOutput } from '../../../services/modules/filterOptions/filterOptions.types';
import { ListCategoryDTO } from '../../orders/products/orderProducts.types';
import { OfflineDatabaseCategory } from '../database/offlineDatabase/types/offlineDatabaseCategory.types';

export class OfflineCategoryTransformers {
  static toFilterOptionsCategory(
    data: OfflineDatabaseCategory,
  ): FindCategoriesFilterOptionsOutput['data'][0] {
    return {
      id: data.id,
      name: data.name,
      code: data.code ?? undefined,
      groupId: data.groupId ?? undefined,
      groupName: data.groupName ?? undefined,
    };
  }

  static toListCategoryDTO(data: OfflineDatabaseCategory): ListCategoryDTO {
    return {
      id: data.id,
      name: data.name,
      children: [],
      imageUrl: '',
      classification: '',
      uniqueSequential: 0,
      parent: !data.groupId
        ? undefined
        : {
            id: data.groupId,
            name: data.groupName || '',
            children: [],
            classification: '',
            imageUrl: '',
            uniqueSequential: 0,
          },
    };
  }
}
